Customer.Conversation ||= {}
Customer.Conversation.Attachments ||= {}

class Customer.Conversation.Attachments.AttachmentImagePreviewView extends Backbone.View
  template: JST['backbone/templates/customer/conversation/attachments/attachment_image_preview']

  events:
    'click #remove-attachment': 'onClickRemove'

  initialize: (@options = {}) ->
    @attachment = @options.attachment

  render: ->
    @$el.html(@template({ image: @attachment }))
    @

  onClickRemove: (evt) ->
    @trigger('remove-attachment', @attachment)

  attachmentUrl: ->
    @attachment
